/*global gardenFormUtil*/
import { gardenFormUtil } from './garden-form-util';
jQuery(function () {
    var form = $('#garden-spot-image-upload-form');
    if (form.length < 1) {
        return;
    }
    var validImageTypes = ['image/jpeg', 'image/png'];
    var fileType;
    $('#garden-spot-image-upload-input').change(function () {
        gardenFormUtil.disableUploadBtn();
        var file = this.files[0];
        gardenFormUtil.hideErrors();
        if (file) {
            fileType = file['type'];
            $('#garden-spot-image-filename').val(file.name);
            $('#garden-spot-image-filename').removeClass('hidden');
            checkAndUploadFile(file);
        }
        else {
            gardenFormUtil.showGenericError();
            $('#garden-spot-image-filename').addClass('hidden');
        }
    });
    function checkAndUploadFile(file) {
        if ($.inArray(fileType, validImageTypes) < 0) {
            gardenFormUtil.showError('Filen du har valt är av fel format.');
        }
        else if (file.size > 10000000) {
            gardenFormUtil.showError('Filen du har valt överstiger gränsen 10 MB.');
        }
        else {
            var img_1 = new Image();
            var objectUrl = window.URL.createObjectURL(file);
            img_1.onload = function () {
                if (img_1.width < 1200 && img_1.width < img_1.height) {
                    gardenFormUtil.showError('Vi rekommenderar att du använder en bild vars form är en ' +
                        'liggande rektangel och som har minsta måttet 1200*500.', true);
                }
                else if (img_1.width < 1200 || img_1.height < 500) {
                    gardenFormUtil.showError('För bästa möjliga kvalité bör din bild minst ha måttet 1200*500.', true);
                }
                else if (img_1.width < img_1.height) {
                    gardenFormUtil.showError('Bilden du har valt är en stående rektangel. Vi rekommenderar att du väljer ' +
                        'en bild vars form är en liggande rektangel.', true);
                }
                else {
                    gardenFormUtil.hideErrors();
                }
                gardenFormUtil.enableUploadBtn();
            };
            img_1.src = objectUrl;
        }
    }
    $('#garden-spot-reset-image').on('click', function () {
        $('#resetImage').val('true');
        $('#garden-spot-image-upload-form').submit();
    });
    $('.js-garden-spot-upload-image-btn').on('click', function () {
        gardenFormUtil.disableUploadBtn();
        gardenFormUtil.hideErrors();
        $('#garden-spot-image-filename').addClass('hidden');
        $('#garden-spot-image-upload-popup').closest('.popup-overlay').addClass('visible');
    });
});
